module.exports = __webpack_public_path__ + "img/U1F579.73639377.png";